module.exports = __webpack_public_path__ + "media/fastweb_college_scholarships_app/app-landing-page-2-a43df071.png";